// firebaseConfig.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth'; // Firebase Authentication için
import { getFirestore } from 'firebase/firestore'; // Firestore veritabanı için
import { getStorage } from 'firebase/storage'; // Firebase Storage için
import { getAnalytics } from 'firebase/analytics'; // Firebase Analytics için

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAqmMnaFdUo9dE7GBe5Kn3_ExqLq2u-47A",
  authDomain: "hops-3.firebaseapp.com",
  projectId: "hops-3",
  storageBucket: "hops-3.firebasestorage.app",
  messagingSenderId: "483627605325",
  appId: "1:483627605325:web:6f110af3155b43d41e2b04",
  measurementId: "G-S2TTK78R7S"
};

// Firebase uygulamasını başlatma
const app = initializeApp(firebaseConfig);

// Authentication, Firestore, Storage ve Analytics'ı başlatma
const auth = getAuth(app);
const database = getFirestore(app);
const storage = getStorage(app);
const analytics = getAnalytics(app);

export { app, auth, database, storage, analytics };